import React, { useState, useEffect } from 'react'
import Loader from '../../Utils/Loader/NewLoader2025'
import { APIGetLoggerEventsModel, buildAPIGetLoggerEventsModel } from "models/APIGetLoggerEventsModel";
import { CreateUrl, CallGetAPI } from 'Utils/ApiHelper.js';
import moment from 'moment'
import { locale, loadMessages } from "devextreme/localization";
import deMessages from "devextreme/localization/messages/de.json";
import frMessages from "devextreme/localization/messages/fr.json";
import esMessages from "devextreme/localization/messages/es.json";
import ptMessages from "devextreme/localization/messages/pt.json";
import { IntlShape, useIntl } from 'react-intl';
import { DataGrid, Column, Export, Scrolling, FilterRow, StateStoring, Pager, Paging, HeaderFilter, DataGridTypes } from 'devextreme-react/data-grid';
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import DateBox, { ValueChangedEvent } from 'devextreme-react/date-box';
import { Button } from '@mui/material';
import Modal from 'react-bootstrap/Modal';
import FullWidthMobileButton from '../FullWidthMobileButton';
import {useMobileLandscape } from '../../Context/ContextProvider'

interface Props {
    serials: Array<string>;
}

const EventsPanelMobile: React.FC<Props> = ({ serials }) => {


    const isLandscape = useMobileLandscape()
    locale(sessionStorage.getItem('language'));
    loadMessages(frMessages);
    loadMessages(deMessages);
    loadMessages(esMessages);
    loadMessages(ptMessages);

    const intl : IntlShape = useIntl()
    const [loading, setLoading] = useState<boolean>(true)
    const [startDate, setStartDate] = useState<Date>(moment().subtract(7, 'days').toDate())
    const [endDate, setEndDate] = useState<Date>(moment().toDate())
    const [events, setEvents] = useState<Array<APIGetLoggerEventsModel>>([])
    const [modal, setModal] = useState<boolean>(false)
    const [selectedEvent, setSelectedEvent] = useState<APIGetLoggerEventsModel | null>()
    useEffect(() => {
        reloadData()
    }, [startDate, endDate])


    const reloadData = () => {
        let eventData = new Array<APIGetLoggerEventsModel>();

        CallGetAPI(CreateUrl('/api/aquaguard/LoggerEvents?serial=' + serials[0] + "&startDate=" + moment(startDate).format("yyyy-MM-DD") + "&endDate=" + moment(endDate).format("yyyy-MM-DD") + "T23:59:59"), {})
            .then(response => {
                eventData = buildAPIGetLoggerEventsModel(response);
                console.log(eventData)
                eventData.forEach(item => {
                    if (item.recordCode && item.eventCode) {
                        item.recordCode = intl.formatMessage({ id: item.recordCode })
                        item.eventCode = intl.formatMessage({ id: item.eventCode })
                    }
                })
                console.log(eventData)
                setEvents(eventData)
                setLoading(false)

            })
            .catch(function (ex) {
                setEvents([])
                console.error(ex);
                setLoading(false)
                return false;
            });
        return true;
    }

    const startDateChanged = (e: ValueChangedEvent<Date | string | number>): void => {
        console.log(e)
        setStartDate(moment(e.value).toDate())
    }

    const endDateChanged = (e: ValueChangedEvent<Date | string | number>):void  => {
        setEndDate(moment(e.value).toDate())
    }

    const renderDetailsButton = (data: DataGridTypes.ColumnCellTemplateData):React.ReactNode => {

        return <Button variant="contained" onClick={():void => { handleDetailsClick(data) } }>Details</Button>
    }

    const toggleModal = ():void => {
        setModal(!modal)
    }

    const handleDetailsClick = (data): void => {
        const clickedEvent = events.find(event => event.id === data.data.id)
        
        setSelectedEvent(clickedEvent)
        toggleModal()
    }

    return (
        <div style={{position: "relative", minHeight: 300} }>
            {loading &&
                <div style={{
                    position: 'absolute', left: 'Calc(50% - 100px)', top: '10%',
                    transform: 'translate(-50%, -50%)',
                    zIndex: 13000
                }}>
                    <Loader color={undefined} />
                </div>
            }
            {!loading &&
                <div>
                    <Modal
                        show={modal}
                        style={{marginTop: 100} }
                    >
                        <Modal.Header>
                            <Modal.Title>
                            Event Details
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>

                            {selectedEvent?.details ? selectedEvent?.details : ""}
                            <p>{selectedEvent?.remainingBattPerc ? `Remaining Battery: ${selectedEvent?.remainingBattPerc}%` : ""}</p>
                            <p>{selectedEvent?.remainingBattYears ? `Remaining Years Of Battery Life: ${selectedEvent?.remainingBattYears}` : ""}</p>
                        </Modal.Body>
                        <Modal.Footer>
                            <FullWidthMobileButton color="primary" onClick={(): void => toggleModal() } text="Exit"/>
                        </Modal.Footer>
                    </Modal>
                    <GridContainer>
                        <div style={{width: "100%", marginLeft: "30px", display: isLandscape ? 'flex' : 'block'  } }>
                            <GridItem xs={12} sm={6} md={6}>
                            {intl.formatMessage({ id: "Start date" })} :&nbsp;<DateBox id="startDate" displayFormat={"dd/MM/yyyy"} value={startDate} onValueChanged={(e: ValueChangedEvent):void => startDateChanged(e)} />
                            </GridItem>
                            <GridItem xs={12} sm={6} md={6}>
                            {intl.formatMessage({ id: "End date" })} :&nbsp;<DateBox id="endDate" displayFormat={"dd/MM/yyyy"} value={endDate} onValueChanged={(e: ValueChangedEvent):void => endDateChanged(e)} />
                            </GridItem>
                        </div>
                        <div style={{margin: "20px 0 0 30px"} }>
                            <DataGrid
                                dataSource={events}
                                scrolling={{
                                    mode: 'standard',
                                    useNative: false
                                }}
                                allowColumnResizing={true}
                                allowColumnReordering={true}
                                style={{border: "1px solid gray"} }
                            >
                                <FilterRow visible={true} />
                                <HeaderFilter visible={true} allowSearch={true} />
                                <Column
                                    dataField="dateCreated"
                                    customizeText={(cellInfo) => {
                                        return moment(cellInfo.value).format("DD MMM HH:mm");
                                    }}
                                    caption={intl.formatMessage({ id: "Last Connected" })}
                                    allowHeaderFiltering={true}
                                    format="date"
                                    width={95} />
                                <Column dataField="eventCode" dataType="string" caption={intl.formatMessage({ id: "Event Code" })} />
                                <Column cellRender={(data): React.ReactNode => renderDetailsButton(data)} width={100 } />
                            </DataGrid>
                        </div>
                    </GridContainer>
                </div>
            }
        </div>
    )
}
export default EventsPanelMobile